export const HEADERS = [
	'Market',
	'Calling mode',
	'Normal mode',
	'Listening score target',
	'Actions',
];
